// extracted by mini-css-extract-plugin
export default {"inspectionReport":"styles_inspectionReport__in2mQ"};